import React, { useMemo } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Form, FormRenderProps } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
// @ts-ignore final-form-focus ships no type declarations
import createFocusOnErrorsDecorator from 'final-form-focus';

import { IFinalFormProps, TDefaultFormValues } from './interfaces';

const FinalForm = <
  FormValues extends TDefaultFormValues = TDefaultFormValues,
  InitialValues = Partial<FormValues>,
>(
  {
    dataTest,
    render,
    withFocusOnErrors = false,
// @ts-ignore TODO: FIN-32798 strictNullChecks
    className = null,
    decorators = [],
    mutators = {},
    ...otherProps
  }: IFinalFormProps<FormValues, InitialValues>,
) => {
  const focusOnErrors = useMemo(() => createFocusOnErrorsDecorator(), []);

  return (
    <Form<FormValues, InitialValues>
      { ...otherProps }
      onSubmit={ otherProps.onSubmit }
      decorators={ [...decorators, ...(withFocusOnErrors ? [focusOnErrors] : [])] }
      // @ts-ignore // TODO: fix strictFunctionTypes types
      mutators={ { ...arrayMutators, ...mutators } }
      render={ (formRenderProps: FormRenderProps<FormValues, InitialValues>) => (
        <form
          data-test={ dataTest }
          className={ className }
          onSubmit={ formRenderProps.handleSubmit }
        >
          { render(formRenderProps) }
        </form>
      ) }
    />
  );
};

export default FinalForm;
